export const COLLAPSED_NAV_SECTIONS_STORAGE_KEY =
  "inssa-studio.collapsedNavSections.v1";

export function toggleCollapsedSection(collapsedSections, title) {
  const next = new Set(collapsedSections);

  if (next.has(title)) {
    next.delete(title);
  } else {
    next.add(title);
  }

  return Array.from(next);
}

export function readCollapsedNavSections(storage) {
  if (!storage) return [];

  try {
    const parsed = JSON.parse(
      storage.getItem(COLLAPSED_NAV_SECTIONS_STORAGE_KEY) || "[]",
    );
    return Array.isArray(parsed)
      ? parsed.map((value) => String(value || "").trim()).filter(Boolean)
      : [];
  } catch (_error) {
    return [];
  }
}

export function writeCollapsedNavSections(storage, collapsedSections) {
  if (!storage) return;

  try {
    storage.setItem(
      COLLAPSED_NAV_SECTIONS_STORAGE_KEY,
      JSON.stringify(
        Array.from(new Set(collapsedSections))
          .map((value) => String(value || "").trim())
          .filter(Boolean),
      ),
    );
  } catch (_error) {
    // localStorage can be unavailable in private windows; collapse state is optional.
  }
}
